// Frans (fr-FR), email: zelfde vorm als email.nl.ts. Tu-vorm; de paden in de links (/instellingen/…)
// blijven zoals ze zijn, dat zijn adressen in de app.
export const emailFr = {
    buttonFallback: 'Le bouton ne marche pas ? Copie ce lien : {url}',
    verify: {
        subject: 'Confirme ton adresse e-mail pour {product}',
        lines: [
            'Bienvenue ! Confirme ton adresse e-mail pour pouvoir utiliser ton tableau familial.',
            'Ce lien est valable 24 heures. Tu n’as pas créé de compte ? Ignore simplement cet e-mail.',
        ],
        cta: 'Confirmer l’adresse e-mail',
    },
    reset: {
        subject: 'Réinitialiser ton mot de passe',
        lines: [
            'Tu as demandé un nouveau mot de passe.',
            'Ce lien est valable 60 minutes et ne fonctionne qu’une fois. Tu n’as rien demandé ? Ignore cet e-mail ; ton mot de passe ne change pas.',
        ],
        cta: 'Choisir un nouveau mot de passe',
    },
    invitation: {
        subject: 'Invitation au tableau familial de {household}',
        lines: [
            'Tu as reçu une invitation pour rejoindre le tableau familial de {household}.',
            'L’invitation est valable 7 jours.',
        ],
        cta: 'Accepter l’invitation',
    },
    // Golf 8 (0050): uitnodiging voor de familiekring. Geen woorden over gezondheid; wel dat het
    // geen alarmdienst is.
    // Golf 8 ronde 1 (ON-3): een huisgenoot uitnodigen (rol parent).
    houseInvite: {
        subject: '{inviter} t’invite dans {household}',
        lines: [
            '{inviter} t’invite dans {household} sur AMUMIN : le planning des tâches, qui mange, les réservations et les frais partagés, sur ton propre téléphone.',
            'Les colocataires ont les mêmes droits que {inviter}.',
            'L’invitation est valable 7 jours.',
        ],
        cta: 'Voir l’invitation',
    },
    circleInvite: {
        subject: '{inviter} vous invite à suivre',
        lines: [
            '{inviter} vous invite à suivre l’écran familial de {household}, en tant que « {label} ».',
            '{name} dit sur l’écran si c’est d’accord. Ensuite, vous ne voyez que ce que {name} autorise.',
            'Ce n’est pas un service d’urgence.',
            'L’invitation est valable 7 jours.',
        ],
        cta: 'Voir l’invitation',
    },
    existingAccount: {
        subject: 'Tu as déjà un compte {product}',
        lines: [
            'Quelqu’un a essayé de créer un nouveau compte avec cette adresse e-mail, mais il en existe déjà un.',
            'C’était toi ? Connecte-toi simplement. Mot de passe oublié ? Demande-en un nouveau avec le bouton ci-dessous.',
            'Ce n’était pas toi ? Tu n’as rien à faire ; rien n’a été modifié.',
        ],
        cta: 'Se connecter',
    },
    newLogin: {
        subject: 'Nouvelle connexion à ton compte {product}',
        lines: [
            'Le {when}, quelqu’un s’est connecté depuis un navigateur que nous ne connaissions pas encore.',
            'C’était toi ? Tu n’as rien à faire.',
            'Ce n’était pas toi ? Change ton mot de passe et déconnecte-toi partout via {origin}/instellingen/beveiliging.',
        ],
    },
    devicePaired: {
        subject: 'Tablette « {device} » associée à {room}',
        lines: [
            'Le {when}, la tablette « {device} » a été associée à la pièce {room} de ton tableau familial.',
            'C’est toi ou ton ou ta partenaire qui l’a fait ? Tu n’as rien à faire.',
            'Tu ne reconnais pas ceci ? Révoque l’association via {origin}/apparaten et change ton mot de passe.',
        ],
    },
    loginCode: {
        subject: '{code} est ton code pour {product}',
        code: 'Ton code : {code}',
        whyNetwork: 'Tu veux ajouter un réseau de confiance. Saisis ce code pour le confirmer.',
        whyLogin: 'Quelqu’un s’est connecté avec ton mot de passe. Saisis ce code dans le même navigateur ; après confirmation, nous faisons confiance à ce navigateur pendant 30 jours (jusqu’au {until}).',
        details: 'Navigateur : {browser} · réseau : {network} · {when}.',
        unknown: 'inconnu',
        validity: 'Le code est valable 10 minutes.',
        warning: 'Nous ne demandons jamais ce code par téléphone, chat ou e-mail ; saisis-le uniquement sur {host}.',
        cta: 'Ce n’était pas moi',
    },
    trustedBrowser: {
        subject: 'Nouveau navigateur de confiance pour {product}',
        someBrowser: 'Un navigateur',
        lines: [
            '{browser} est maintenant un navigateur de confiance, valable jusqu’au {until}.',
            'Dans ce navigateur, nous ne demandons plus de code e-mail jusque-là ; ton mot de passe reste toujours nécessaire.',
            'Ce n’était pas toi ? Change ton mot de passe et oublie tous les navigateurs via {origin}/instellingen/beveiliging.',
        ],
    },
    trustedNetwork: {
        subject: '{label} {verb} par {name}',
        verbs: {
            added: 'ajouté comme réseau de confiance (pas encore confirmé)',
            confirmed: 'confirmé comme réseau de confiance',
            updated: 'modifié',
            disabled: 'désactivé comme réseau de confiance',
            removed: 'supprimé des réseaux de confiance',
        },
        household: 'Ceci s’applique à tous les parents du foyer : depuis ce réseau, nous ne demandons pas de code e-mail après le mot de passe.',
        identity: 'Ceci s’applique uniquement à {name}.',
        check: 'Ce n’est pas correct ? Consulte les réseaux de confiance via {origin}/instellingen/beveiliging.',
    },
    lockout: {
        subject: 'Connexion par code e-mail bloquée temporairement',
        lines: [
            'Trop de codes de connexion ont été demandés ou mal saisis. Jusqu’à {until}, nous n’envoyons plus de nouveaux codes.',
            'Ce n’était pas toi ? Quelqu’un d’autre connaît peut-être ton mot de passe : change-le avec « Mot de passe oublié ».',
        ],
    },
    wanChanged: {
        subject: 'L’adresse Internet de ton serveur a changé',
        lines: [
            'Le {when}, le serveur a reçu une nouvelle adresse Internet de ton fournisseur.',
            'Le réseau de confiance « Maison (WAN) » suit ce changement automatiquement. Tu ne t’y attendais pas ? Vérifie ta box et les réseaux de confiance.',
        ],
    },
    recoveryReuse: {
        subject: 'Attention : tablette « {device} » marquée comme suspecte',
        lines: [
            'Le jeton de récupération de la tablette « {device} » a été utilisé une deuxième fois.',
            'La tablette est marquée temporairement comme suspecte. Vérifie dans l’appli, sous Appareils, que tout est correct, puis confirme ou révoque l’association.',
        ],
    },
    familyLink: {
        subject: '{name} veut associer ton tableau familial',
        lines: [
            '{name} veut partager quelques éléments avec ta famille, comme les anniversaires et les listes d’envies.',
            'Tu choisis ensuite toi-même ce que ta famille partage en retour. L’invitation est valable 7 jours.',
            'Pas encore de {product} ? Crée d’abord un compte gratuit avec cette adresse e-mail.',
        ],
        cta: 'Voir l’association',
    },
    billing: {
        signupCode: {
            subject: '{code} est ton code pour terminer ton inscription',
            lines: [
                'Bienvenue sur {product} ! Ton code est {code}.',
                'Saisis le code sur l’écran où tu t’inscris, ou utilise le bouton ci-dessous dans le même navigateur.',
                'Le code est valable 10 minutes et le bouton 24 heures. Tu ne t’es pas inscrit ? Ignore cet e-mail ; rien ne se passera.',
                'Nous ne demandons jamais ce code par téléphone, chat ou e-mail ; saisis-le uniquement sur {host}.',
            ],
            cta: 'Terminer l’inscription',
        },
        priceLine: 'Ensuite, cela coûte {price}. Tu peux résilier à tout moment.',
        priceUnknown: 'Nous te dirons bien avant la fin ce que cela coûte ensuite. Tu peux résilier à tout moment.',
        perMonth: '{amount} par mois',
        trialWelcome: {
            subject: 'Bienvenue ! Ton mois d’essai dure jusqu’au {date} inclus',
            lines: [
                'Merci d’utiliser {product}. Le premier mois est gratuit, jusqu’au {date} inclus.',
                'Tu n’as rien à payer ni à remplir maintenant. Une semaine avant la fin, nous t’enverrons un rappel.',
            ],
            cta: 'Ouvrir l’application',
        },
        trialReminder7d: {
            subject: 'Encore une semaine gratuite : ton essai dure jusqu’au {date}',
            lines: [
                'Ton mois d’essai de {product} dure jusqu’au {date} inclus.',
                'Tu veux continuer ensuite ? Ajoute tes données de paiement dans Réglages › Abonnement.',
                'Si tu ne fais rien, tu pourras encore tout consulter, mais plus rien ajouter ni modifier. Nous n’effaçons rien.',
            ],
            cta: 'Voir l’abonnement',
        },
        trialReminder1d: {
            subject: 'Aujourd’hui est ton dernier jour gratuit',
            lines: [
                'Aujourd’hui ({date}) est le dernier jour de ton mois gratuit de {product}.',
                'Tu veux continuer sans interruption ? Ajoute aujourd’hui tes données de paiement dans Réglages › Abonnement.',
                'Si tu ne fais rien, le tableau passe demain en lecture seule. Tes données restent conservées.',
            ],
            cta: 'Ajouter les données de paiement',
        },
        trialExpired: {
            subject: 'Ton mois d’essai est terminé',
            lines: [
                'Ton mois gratuit de {product} est terminé. Tout est encore là : tu peux consulter l’agenda et le reste, aussi sur le tableau.',
                'Ajouter et modifier redevient possible dès que tu as ajouté tes données de paiement.',
                'Tu veux arrêter ? Tu n’as rien à faire. Nous n’effaçons jamais tes données de nous-mêmes ; tu peux les supprimer dans Réglages › Tes données.',
            ],
            cta: 'Voir l’abonnement',
        },
        expiredFollowup: {
            subject: 'Voulez-vous continuer avec {product} ?',
            lines: [
                'Votre mois d’essai s’est terminé il y a un mois. Le tableau est toujours en lecture seule.',
                'Vous pouvez continuer à tout moment : ajoutez vos données de paiement dans Réglages › Abonnement.',
                'Vous préférez arrêter ? Résiliez ou supprimez le tableau familial dans Réglages › Tes données. Nous ne vous écrirons plus à ce sujet.',
            ],
            cta: 'Voir l’abonnement',
        },
        cancelled: {
            subject: 'Ton abonnement est résilié',
            lines: [
                'Tu as résilié ton abonnement à {product}. Jusqu’au {date} inclus, tout fonctionne comme maintenant.',
                'Ensuite, tu pourras tout consulter, mais plus rien modifier. Nous n’effaçons rien de nous-mêmes.',
                'Tu as changé d’avis ? Tu peux continuer jusqu’au {date} inclus dans Réglages › Abonnement.',
            ],
            cta: 'Voir l’abonnement',
        },
    },
};
//# sourceMappingURL=email.fr.js.map